import React from 'react';
import styled from 'styled-components';
import { SubHeading } from '../';
import { colors } from '../../variables';

const BaseCard = styled.div`
	background: #fff;
	border: 1px solid ${colors.grey.normal};

	> header {
		padding: 20px;
		border-bottom: 1px solid ${colors.grey.normal};
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
`;

const getContentClassName = className => `p20 ${className || ''}`;

const Card = ({
	title,
	children,
	contentClassName,
	headerActionElement,
	...rest
}) => (
	<BaseCard {...rest}>
		<header>
			<SubHeading primary className="mv0 d-ib">
				{title}
			</SubHeading>

			{headerActionElement}
		</header>

		<div className={getContentClassName(contentClassName)}>{children}</div>
	</BaseCard>
);

export default Card;



// WEBPACK FOOTER //
// ./src/components/Common/Card/Card.js